import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import ScrollReveal from "../../components/feature/ScrollReveal";
import LegalSection from "../../components/feature/LegalSection";
import { useTokushohoData } from "../../lib/useMockData";

export default function Tokushoho() {
  const { heroData, summaryText, sections, enactedDate } = useTokushohoData();
  return (
    <PageLayout>
      <InfoPageHero
        label={heroData.label}
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="特定商取引法に基づく表記"
      />

      <section className="py-14 md:py-20 bg-airdoa-white">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <ScrollReveal direction="up">
              <div className="mb-8 md:mb-10 pb-6 md:pb-8 border-b border-airdoa-gray-light">
                <p className="text-sm text-airdoa-gray leading-relaxed">
                  {summaryText}
                </p>
                <p className="mt-3 text-xs text-airdoa-gray-light">
                  制定日：{enactedDate}
                </p>
              </div>
            </ScrollReveal>

            <div className="flex flex-col gap-8 md:gap-10">
              {sections.map((section, idx) => (
                <LegalSection
                  key={section.title}
                  title={section.title}
                  items={section.items}
                  index={idx}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <InfoPageFinalCTA
        title={`ご不明な点がございましたら\nお気軽にお問い合わせください`}
        ctas={[
          {
            label: "お問い合わせページへ",
            href: "/contact",
            type: "primary",
          },
          { label: "キャンセルポリシー", href: "/cancel-policy", type: "secondary" },
        ]}
      />

      <InfoPageFooter />
    </PageLayout>
  );
}